var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46 512h420c8.284 0 15-6.716 15-15v-151c0-4.197-1.758-8.201-4.848-11.042l-25.152-23.126c0-12.583 0-282.957 0-296.832 0-8.284-6.716-15-15-15-20.165 0-371.443 0-390 0-8.284 0-15 6.716-15 15v482c0 8.284 6.716 15 15 15zm163.733-422h121.267v75c0 8.284 6.716 15 15 15h75v104.248zm190.054 60h-38.787v-38.787zm21.213-21.213-64.386-64.386c-2.765-2.778-6.676-4.401-10.614-4.401h-168.896l-32.628-30h276.524zm-360-98.787h39.152c22.555 20.738 334.119 307.203 350.848 322.585v129.415h-390z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 361h-120c-8.284 0-15 6.716-15 15v60c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-60c0-8.284-6.716-15-15-15zm-15 60h-90v-30h90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 301h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226 241h-120c-8.284 0-15 6.716-15 15s6.716 15 15 15h120c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.2450890851a2503f3daf6007996bff89.svg";
export { ForwardRef as ReactComponent };